import React from 'react';

const MentionsLegales: React.FC = () => {
  return (
    <div className="bg-white py-16 px-4 sm:px-6 lg:px-8 lg:py-24">
      <div className="max-w-3xl mx-auto">
        <div className="text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-gray-900">
            Mentions légales
          </h1>
          <p className="mt-2 text-lg text-gray-600">
            En vigueur au 11/07/2025
          </p>
        </div>

        <div className="mt-12 space-y-12 text-gray-700">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900">1. Éditeur du site</h2>
            <p className="mt-2">
              Le site <strong>api100.io</strong> est édité par :<br />
              <strong>Global Gestion Sàrl</strong><br />
              Route de Collex 22D, 1294 Genthod, Suisse<br />
              IDE/TVA : CHE-105.160.410<br />
              ✉️ <a href="mailto:contact@api100.io" className="text-blue-600 hover:underline">contact@api100.io</a><br />
              ☎️ +41 58 332 23 70
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">2. Hébergement</h2>
            <p className="mt-2">
              Le site est hébergé par :<br />
              <strong>Infomaniak Network SA</strong><br />
              Rue Eugène-Marziano 25, 1227 Les Acacias, Genève, Suisse<br />
              🌐 <a href="https://www.infomaniak.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">www.infomaniak.com</a><br />
              Les données sont hébergées en Suisse dans un datacenter écologique alimenté à 100 % par des énergies renouvelables. La chaleur générée est revalorisée pour chauffer le quartier.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">3. Propriété intellectuelle</h2>
            <p className="mt-2">
              L’ensemble des contenus, marques, logos, graphismes, structures, codes et autres éléments présents sur le site <strong>api100.io</strong> sont la propriété exclusive de Global Gestion Sàrl ou font l’objet d’une licence d’utilisation. Toute reproduction, distribution ou exploitation non autorisée est strictement interdite.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">4. Données personnelles</h2>
            <p className="mt-2">
              Les données personnelles collectées via le site sont traitées conformément à notre <a href="/privacy-policy" className="text-blue-600 hover:underline">Politique de confidentialité</a>, dans le respect de la LPD suisse et du RGPD européen. Aucune donnée de contenu n’est stockée, seules des statistiques anonymes sont collectées.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">5. Contact</h2>
            <p className="mt-2">
              Pour toute question ou réclamation concernant le site ou son contenu, vous pouvez nous contacter à :<br />
              ✉️ <a href="mailto:contact@api100.io" className="text-blue-600 hover:underline">contact@api100.io</a><br />
              ☎️ +41 58 332 23 70
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;
